/** Debounce delay for Assets overview search, aligned with Back Office. */
export const ASSET_OVERVIEW_SEARCH_DEBOUNCE_MS = 300;

/**
 * Normalizes the Assets overview search input for the list API `q` param.
 * Empty / whitespace-only values clear the filter.
 */
export function toAssetOverviewSearchQuery(
  searchValue: string,
): string | undefined {
  const normalized = searchValue.trim();
  return normalized || undefined;
}
